import { FC, useState } from 'react'
import { Button, message, Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { translate, memory } from '../index'
import { HttpRequest } from '../http.service'
import { AUTHENTICATION_TOKEN } from '../../App.constants'
import { TokenResponse } from '../../app/auth/type'
import { UploadImageResponse } from '../../app/shared/type'

type Props = {
  onUploaded: (filename: string) => void
  label?: string
  buttonSize?: 'small' | 'middle' | 'large'
  onUploadingChange?: (uploading: boolean) => void
}

const getAuthHeaders = (): Record<string, string> => {
  const token = memory.get<TokenResponse>(AUTHENTICATION_TOKEN)
  if (!token?.access_token) return {}
  return { Authorization: `${token.token_type} ${token.access_token}` }
}

export const ImageUpload: FC<Props> = ({ onUploaded, label, buttonSize, onUploadingChange }) => {
  const [uploading, setUploading] = useState(false)

  const setUploadingState = (state: boolean) => {
    setUploading(state)
    onUploadingChange?.(state)
  }

  return (
    <Upload
      action={`${new HttpRequest().baseURL}/files/image`}
      name="images"
      headers={getAuthHeaders()}
      showUploadList={false}
      beforeUpload={(file) => {
        if (file.type.includes('image/')) return true
        message.error(translate('upload_format'))
        return false
      }}
      onChange={({ file }) => {
        if (file.status === 'uploading') {
          setUploadingState(true)
        } else if (file.status === 'done') {
          setUploadingState(false)
          const [{ filename }] = file.response as UploadImageResponse[]
          onUploaded(filename)
        } else if (file.status === 'error') {
          setUploadingState(false)
          message.error(translate('upload') + ' ' + translate('error'))
        }
      }}
    >
      <Button size={buttonSize} loading={uploading} icon={<PlusOutlined />}>
        {uploading ? translate('uploading') : label ?? translate('upload')}
      </Button>
    </Upload>
  )
}
